import { useCallback } from 'react';

import { DataTrackerEventData } from 'approot/shared/data-tracker/data-tracker.constants';
import { PrimaryButton } from 'approot/shared/styles/buttons';
import { SecondaryButton } from 'approot/shared/styles/buttons/secondary-button.style';
import { pushDataTrackerEvent } from 'approot/shared/data-tracker/data-tracker-push';

export const PRIMARY = 'primary';
export const SECONDARY = 'secondary';

export type AssignVariant = typeof PRIMARY | typeof SECONDARY;

export type Props = {
  variant?: AssignVariant;
  isSmall?: boolean;
  isDisabled?: boolean;
  assigned: boolean;
  dataEvent?: {
    category: string;
    action: string;
    data: DataTrackerEventData;
  };
  dataSelector?: string;
  onAssignSelect?: () => void;
};

const AssignButton = ({
  variant = PRIMARY,
  isSmall,
  isDisabled,
  assigned,
  dataEvent,
  dataSelector,
  onAssignSelect,
}: Props) => {
  const handleSelect = useCallback(() => {
    if (dataEvent) {
      pushDataTrackerEvent(
        dataEvent.category,
        dataEvent.action,
        dataEvent.data
      );
    }
    onAssignSelect?.();
  }, [dataEvent, onAssignSelect]);

  return (
    <>
      {assigned || variant === PRIMARY ? (
        <PrimaryButton
          type="button"
          $isSmall={isSmall}
          disabled={isDisabled}
          variant={assigned ? 'outlined' : 'default'}
          data-selector={dataSelector ? dataSelector : 'bookmark'}
          data-selector-action={assigned ? 'remove-bookmark' : 'add-bookmark'}
          onClick={handleSelect}
        >
          {assigned ? 'Assigned' : 'Assign'}
        </PrimaryButton>
      ) : (
        <SecondaryButton
          type="button"
          $isSmall={isSmall}
          disabled={isDisabled}
          data-selector={dataSelector ? dataSelector : 'bookmark'}
          data-selector-action={assigned ? 'remove-bookmark' : 'add-bookmark'}
          onClick={handleSelect}
        >
          Assign
        </SecondaryButton>
      )}
    </>
  );
};

export default AssignButton;
